import { GetVehiclePartQueryParamsType } from '@/common/queries/selections/getVehiclePart/getVehiclePartQuery.type';
import { getVehiclePartFunction } from '@/common/queries/selections/getVehiclePart/getVehiclePartQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getVehiclePartQueryOptions = (
  params: GetVehiclePartQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['VehiclePart', params],
    queryFn: () => getVehiclePartFunction(params),
    enabled: params.enabled,
  });
};
